<template>
  <div>
    <s3-upload
    :project="project"
      @complete="handleS3UploadComplete"
      @start="isSaving = true"
      @error="isSaving = false"/>

    <div v-if="isSaving" class="overlay">
      <div class="text-center mt-5">
        <i class="fa fa-spinner fa-spin fa-3x text-primary"/>
      </div>
    </div>
  </div>
</template>

<script>
  import VueUploadComponent from 'vue-upload-component';
  import S3Upload from './S3Upload';
  import {registerListener, unregisterListener} from '../../tasks';
  import {fetchUploadedFile} from '../../store/files';
  import axios from 'axios';
  import {fullURL} from '../../utils';
  import { initSegments } from '../../store/segments';

  export default {
    name: 'UploadWithDragAndDrop',

    components: {
      FileUpload: VueUploadComponent,
      S3Upload
    },

    props: {
      fileType: String,
      project: Object
    },

    data() {
      return {
        isSaving: false
      };
    },

    methods: {
      handleS3UploadComplete(file) {
        file = {
          ...file,
          type: this.fileType,
          projectID: (!!this.project && !!this.project.id) ? this.project.id : null,
        };

        this.isSaving = true;
        axios.post(fullURL('/file'), file)
          .then(({data}) => this.monitorTask(data))
          .catch(e => {
            console.log(e);
            this.isSaving = false;
          });
      },

      monitorTask(taskID) {
        registerListener(taskID, (event, data) => {
          if (event === 'success') {
            if (!!data.fileID) {
              this.$store.dispatch(initSegments())
              .then(() => {
                console.log("All segments have been refreshed!!!");
              })
              .catch(console.log);
              this.$store.dispatch(fetchUploadedFile(data.fileID))
              .then(() => {
                this.$emit('success', {'fileID': data.fileID});
              })
              .catch(console.log)
              .finally(() => {
                this.isSaving = false;
              });
            } else {
              this.$emit('fail', {'fileID': null, 'recordsLeft': data.records_left, 'rowCount': data.row_count});
            }
          } else if (event === 'failure') {
            console.log('The process failed', data.message);
          } else {
            return;
          }

          unregisterListener(taskID);
        });
      }
    }
  };
</script>

<style scoped>
  .overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .6);
  }
</style>
